/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import { Column } from "../../../../common/commonComponents/mediaPreparationTable";
import { ReconPowderBatchDetails } from "../reconcilePowder.types";

export const getMediaReconciliationColumns = (t: any): Column[] => [
	{
		header: t('mediaReconcile.tableColumns.mediaBatchDetails'),
		key: "batch_name",
		render: (row: ReconPowderBatchDetails) => (
			<td className="px-6 py-4">
				<div className="flex flex-col">
					<span className="font-black text-slate-800 text-sm tracking-tight">
						{row.lot_number}
					</span>
					<span className="text-[10px] text-slate-400 font-mono font-bold uppercase tracking-wider mt-1">
						{row.media_name}
					</span>
				</div>
			</td>
		),
	},
	{
		header: t('mediaReconcile.tableColumns.systemStock'),
		key: "system_stock_display",
		render: (row: ReconPowderBatchDetails) => (
			<td className="px-6 py-4">
				<span className="font-black text-slate-700 text-sm tracking-tight">
					{row.system_stock_display}
				</span>
			</td>
		),
	},
	{
		header: t('mediaReconcile.tableColumns.lastReconciled'),
		key: "last_reconciled_at",
		render: (row: ReconPowderBatchDetails) => (
			<td className="px-6 py-4">
				<span className="text-xs font-bold text-slate-500">
					{row.last_reconciled_at}
				</span>
			</td>
		),
	},
	{
		header: t('mediaReconcile.tableColumns.status'),
		key: "batch_status",
		render: (row: ReconPowderBatchDetails) => (
			<td className="px-6 py-4">
				<span
					className={`px-3 py-1 rounded-full text-[9px] font-black uppercase tracking-widest border ${
						row.qa_release_status === "Quarantine"
							? "text-blue-700 bg-blue-50 border-blue-100"
						: row.qa_release_status === "RELEASED"
							? "text-green-600 bg-green-50 border-green-200"
						: row.qa_release_status === "REJECTED"
							? "text-red-600 bg-red-50 border-red-200"
							: "text-gray-600 bg-gray-50 border-gray-200"
					}`}
				>
					{row.qa_release_status}
				</span>
			</td>
		),
	},
	{
		header: t('mediaReconcile.tableColumns.reconciliationStatus'),
		key: "reconciliation_status",
		render: (row: ReconPowderBatchDetails) => (
			<td className="px-6 py-4">
				<span
					className={`px-3 py-1 rounded-full text-[9px] font-black uppercase tracking-widest border ${
						row.reconciliation_status === "PENDING"
							? "text-blue-700 bg-blue-50 border-blue-100"
						: row.reconciliation_status === "OVERDUE"	
							? "text-red-700 bg-red-50 border-red-100"
							: 'text-green-700 bg-green-50 border-green-100'
					}`}
				>
					{row.reconciliation_status}
				</span>
			</td>
		),
	},
];
